export const FILE_CREATOR_ROLE_SKLADON_EMPLOYEE = 'skladon_employee' as const;
export const FILE_CREATOR_ROLE_CLIENT = 'client' as const;

export type FileCreatorRole =
    | typeof FILE_CREATOR_ROLE_SKLADON_EMPLOYEE
    | typeof FILE_CREATOR_ROLE_CLIENT;
